<template>
  <Loader
    :loader="pageLoader"
    label="Carregando..."
    loaderType="progress"
    loaderSize="h-96"
  />

  <main v-if="!pageLoader">
    <section class="flex justify-between items-center">
      <h3>
        {{ $t("quiz.result.title") }}
      </h3>
    </section>
    <section class="mt-5">
      <Header
        :data="quizResult"
        :learningName="learningName"
        :isAdaptative="isAdaptative"
        @onProceed="onProceed"
      />
      <div id="empty" class="mt-8">
        <EmptyData
          :data="
            quizResult?.questionAnswers?.length === 0 &&
            quizResult?.absQuestionAnswers?.length === 0
          "
          :label="$t('quiz.result.empty')"
          msgSize="w-5/12"
        />
      </div>
      <div
        v-if="
          quizResult?.questionAnswers?.length !== 0 ||
          quizResult?.absQuestionAnswers?.length !== 0
        "
        class="flex flex-col gap-5 mt-8"
      >
        <div
          v-for="(answer, indexAnswer) in quizResult?.questionAnswers"
          :key="indexAnswer"
        >
          <div class="bg-white p-3 shadow-md rounded-md">
            <p class="font-bold">
              {{ answer.question?.prompt }}
            </p>
            <div class="my-5">
              <p>
                <strong>
                  {{
                    $t("labels.generic", {
                      pt: "Resposta: ",
                      en: "Answer: ",
                    })
                  }}
                </strong>
                {{ answer.selectedItem?.answerText }}
              </p>
              <div>
                <div class="flex items-center gap-2 mt-5 text-lg">
                  <v-icon
                    :name="`${
                      answer.question?.correctItem?.id ===
                      answer.selectedItem?.id
                        ? 'hi-solid-check-circle'
                        : 'hi-solid-x-circle'
                    }`"
                    :scale="1.3"
                    :class="
                      answer.question?.correctItem?.id ===
                      answer.selectedItem?.id
                        ? 'text-green-500'
                        : 'text-red-700'
                    "
                  />
                  <p>
                    {{
                      answer.question?.correctItem?.id ===
                      answer.selectedItem?.id
                        ? $t("quiz.right")
                        : $t("quiz.wrong")
                    }}
                  </p>
                </div>
                <p class="mt-1">
                  {{ answer.selectedItem?.answerDescription }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          v-for="(answer, indexAnswer) in quizResult?.absQuestionAnswers"
          :key="indexAnswer"
        >
          <DragDropCardResult
            v-if="answer.question.type === type.DRAG_AND_DROP"
            :answer="answer"
          />
          <TrueOrFalseCardResult
            v-if="answer.question.type === type.TRUE_OR_FALSE"
            :answer="answer"
          />
          <GapCardResult
            v-if="answer.question.type === type.FILL_IN_THE_BLANKS"
            :answer="answer"
          />
        </div>
      </div>
    </section>
  </main>
</template>

<script lang="ts">
import { QuizResult } from "@/models/quiz.model";
import { CourseStore } from "@/store/course";
import { delay } from "rxjs";
import { defineAsyncComponent, defineComponent } from "vue";
import { QuizService } from "../../quiz.service";
import { QuestionType } from "@/models/quiz.model";
const Header = defineAsyncComponent(() => import("./result-header.vue"));
const DragDropCardResult = defineAsyncComponent(
  () => import("./QuizResult/question-result-drag-drop-card.vue")
);
const TrueOrFalseCardResult = defineAsyncComponent(
  () => import("./QuizResult/question-result-true-false-card.vue")
);
const GapCardResult = defineAsyncComponent(
  () => import("./QuizResult/question-result-gap-card.vue")
);

export default defineComponent({
  name: "quizResult",
  emits: ["onProceed", "onPercentageQuizResult", "onClose"],
  components: {
    Header,
    DragDropCardResult,
    GapCardResult,
    TrueOrFalseCardResult,
  },
  computed: {
    service(): QuizService {
      return new QuizService();
    },
    type(): typeof QuestionType {
      return QuestionType;
    },
  },
  props: {
    isAdaptative: {
      type: Boolean,
      default: true,
    },
    learningId: [String],
    learningName: [String],
  },
  data() {
    return {
      quizResult: new QuizResult(),
      selected: null as any,
      pageLoader: true as boolean,
    };
  },
  mounted() {
    this.getQuizResult();
  },
  methods: {
    getQuizResult(): void {
      this.service.result.pipe(delay(1000)).subscribe({
        next: (response) => {
          if (response?.questionAnswers) {
            this.quizResult = response;
            this.selected = response?.questionAnswers;
            this.pageLoader = false;
            CourseStore.setQuiz(response);
            this.$emit("onPercentageQuizResult", response.percentage);
          } else this.$emit("onClose");
        },
      });
      this.service.getQuizResult(this.learningId!!);
    },
    onProceed(type: string): void {
      this.$emit("onProceed", type);
    },
  },
});
</script>
